import { randomUuidV4 } from '@saniplus/api-client';

/**
 * The idempotency key (D-10). One per tap, generated before anything is
 * written or sent, so a punch replayed nine times by an impatient worker on a
 * bad connection is still exactly one punch (I-6).
 *
 * `randomUuidV4` rather than `crypto.randomUUID` directly: the latter is
 * secure-context only, and some Android WebViews and older Safari builds ship
 * `getRandomValues` alone. A punch must not depend on which.
 */
export function newClientPunchUuid(): string {
  return randomUuidV4();
}
